import { useState } from "react";
import { AlertTriangle, Power, ShieldCheck, ShieldOff } from "lucide-react";
import { Button } from "@/components/ui/button";

export const LiveTradingControls = ({ data, busy, onCheck, onEnable, onDisarm, onEmergencyStop }) => {
  const [confirming, setConfirming] = useState(false);
  const [confirmingEmergency, setConfirmingEmergency] = useState(false);
  const state = data?.arming_state || "DISARMED";
  const ready = state === "READY";
  const enabled = state === "ENABLED";
  const emergency = Boolean(data?.emergency_stop_all_mutations);
  return <section className="live-control-band" data-testid="live-trading-controls">
    <div className="live-warning" data-testid="live-real-money-warning">
      <AlertTriangle aria-hidden="true" />
      <div><strong>真钱交易环境</strong><span>发布或保存凭证不会自动启用；固定风险 50 USDT / 单。</span></div>
    </div>
    <div className="arming-state" data-state={state} data-testid="live-arming-state">
      <span>ARMING STATE</span><strong>{state}</strong>
    </div>
    <Button variant="outline" disabled={busy || enabled || !data?.credentials_configured}
      onClick={onCheck} data-testid="live-check-connection-button">
      <ShieldCheck aria-hidden="true" />检查连接
    </Button>
    {!enabled && <Button variant="destructive" disabled={busy || !ready}
      onClick={() => setConfirming(true)} data-testid="live-enable-button">
      <Power aria-hidden="true" />启用实盘自动交易
    </Button>}
    {enabled && <Button variant="outline" disabled={busy} onClick={onDisarm}
      data-testid="live-disarm-button"><ShieldOff aria-hidden="true" />停止新开仓</Button>}
    <Button variant="destructive" disabled={busy || emergency}
      onClick={() => setConfirmingEmergency(true)} data-testid="live-emergency-stop-button">
      <AlertTriangle aria-hidden="true" />紧急停止全部
    </Button>
    {emergency && <>
      <div className="live-warning" data-testid="live-emergency-active">
        <AlertTriangle aria-hidden="true" /><div><strong>紧急停止已开启</strong>
        <span>全部交易 API 动作已暂停，包括已有仓位保护；请人工检查 OKX 仓位。</span></div>
      </div>
      <Button variant="outline" disabled={busy} onClick={onDisarm}
        data-testid="live-resume-protection-button">
        <ShieldCheck aria-hidden="true" />恢复仅保护模式
      </Button>
    </>}
    {confirmingEmergency && <div className="live-confirmation" role="alertdialog"
      data-testid="live-emergency-confirmation-dialog">
      <strong>确认紧急停止全部交易 API 动作？</strong>
      <p>这会同时停止新开仓和已有仓位的自动止损、TP、减仓、保护修复与对账。仅在必须完全切断自动交易时使用。</p>
      <div><Button variant="destructive" disabled={busy}
        onClick={() => { setConfirmingEmergency(false); onEmergencyStop(); }}
        data-testid="live-emergency-confirm-button">确认紧急停止</Button>
      <Button variant="outline" onClick={() => setConfirmingEmergency(false)}
        data-testid="live-emergency-cancel-button">取消</Button></div>
    </div>}
    {confirming && <div className="live-confirmation" role="alertdialog"
      data-testid="live-enable-confirmation-dialog">
      <strong>确认启用真钱自动交易？</strong>
      <p>只处理确认时间之后的新信号；不会复制 Demo 仓位、WAIT 或历史信号。</p>
      <div><Button variant="destructive" disabled={busy}
        onClick={() => { setConfirming(false); onEnable(); }}
        data-testid="live-enable-confirm-button">确认启用 LIVE</Button>
      <Button variant="outline" onClick={() => setConfirming(false)}
        data-testid="live-enable-cancel-button">取消</Button></div>
    </div>}
  </section>;
};